export enum UserFilterDropdownEnum {
    all = 'all',
    category = 'category',
    subcategory = 'subcategory',
    manufacturer = 'manufacturer',
    condition = 'condition',
    exw = 'exw',
    promotional = 'promotional'
}
